import Swal from 'sweetalert2'

export const errorAlert = (error: any,callback:Function) => {
    let message : string = "";
    if ((typeof error === "string" || error instanceof String)) {
        message = <string>error;
    } else {
        if (error.message == "Request aborted") {
            return;
        }
        message = (typeof error.message !== "undefined" ? error.message : "");
        if (typeof error.response !== "undefined") {
            if (typeof error.response.data.message !== "undefined") {
                message = error.response.data.message;
            }
            if (typeof error.response.data.errors !== "undefined") {
                message = "";
                for (let errorItem in error.response.data.errors) {
                    message += error.response.data.errors[errorItem][0] + "<br>";
                }
            }
        }
    }
    Swal.fire({
        title: 'エラー',
        html: message,
        icon: 'error',
        showCancelButton:false,
        confirmButtonText: 'OK'
    }).then(() => {
        if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.location !== "undefined") {
            window.location = error.response.data.location;
        } else {
            if (typeof callback !== 'undefined') {
                callback();
            }
        }
    });
}

export const successAlert = (success: any,callback:Function) => {
    let message = success;
    Swal.fire({
        title: '情報',
        html: message,
        icon: 'success',
        showCancelButton:false,
        confirmButtonText: 'OK'
    }).then(() => {
        if (typeof callback !== 'undefined') {
            callback();
        }
    });
}

export const confirmAlert = async (confirmMessage: string) : Promise<any> => {
    return Swal.fire({
        title: '確認',
        html: confirmMessage,
        focusConfirm: true,
        icon: 'info',
        showCancelButton:true,
        confirmButtonText: 'はい',
        cancelButtonText:'いいえ'
    });
}
